import React from 'react';
// import { Route, Link } from "react-router-dom";



const Imprint = () => (
    <div>
      <div className="cb-imprint">

        <h2>Impressum</h2>

        <div className={"cb-fullwidth"}>
          <p>
            Inhaltlich verantwortlich: Christoph Breitbach
          </p>
          <p>
            Mobil: +49 (0) 163 31 32 336<br />
            E-Mail: <a href="mailto:mail@christophbreitbach.de" className={"cb-link"}>mail@christophbreitbach.de</a><br />
            www.christophbreitbach.de
          </p>
          <p>
            Steuernummer: 153/5030/1996<br />
            Finanzamt Düsseldorf-Hilden
          </p>
          <p>
            Haftungshinweis:<br />
            Trotz sorgfältiger inhaltlicher Kontrolle wird keine Haftung für die Inhalte externer Links übernommen. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
          </p>
          <p>
            Copyright:<br />
            Alle gezeigten Arbeiten und Ideen sind geistiges Eigentum von Christoph Breitbach bzw. der ihn beauftragenden Unternehmen.
            Verwendung nur mit ausdrücklicher schriftlicher Genehmigung.
          </p>
          <p>
            Stand: 06/2025
          </p>
        </div>

      </div>
    </div>
);

export { Imprint };


// WEBPACK FOOTER //
// ./src/includes/Imprint.jsx